import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { FullScreenLoading, PageContainer } from '../../components'

export default function SectionContent() {
  return (
    <Suspense fallback={<FullScreenLoading />}>
      <main className="h-full w-full overflow-auto">
        <PageContainer className="h-[inherit]">
          <Outlet />
        </PageContainer>
      </main>
    </Suspense>
  )
}
